import type { SidebarItem } from 'vue-sidebar-menu';

export type AppMenuItem = Omit<SidebarItem, 'child'> & {
  child?: AppMenuItem[];
  requiresEditMode?: boolean;
};

const menuItems: AppMenuItem[] = [
  {
    href: '/dashboard/overview',
    title: 'menu.dashboard',
    icon: 'mdi mdi-view-dashboard',
  },
  {
    title: 'menu.catalogue.default',
    icon: 'mdi mdi-clipboard-list',
    child: [
      {
        href: '/groupable/asset/groups',
        title: 'menu.catalogue.assets',
      },

      {
        title: 'menu.catalogue.threats',
        child: [
          {
            href: '/groupable/threat/groups',
            title: 'menu.catalogue.threats',
          },
          {
            href: '/catalogue/threat-sources',
            title: 'menu.catalogue.threatSources',
          },
          {
            href: '/catalogue/threat-source-types',
            title: 'menu.catalogue.threatSourceTypes',
          },
        ],
      },
      {
        href: '/groupable/vulnerability/groups',
        title: 'menu.catalogue.vulnerabilities',
      },
      {
        href: '/catalogue/impacts',
        title: 'menu.catalogue.impacts',
      },
      {
        href: '/catalogue/imp-exp',
        title: 'menu.catalogue.imp-exp',
        requiresEditMode: true,
      },
    ],
  },
  {
    title: 'menu.risk-analyse.default',
    icon: 'mdi mdi-asterisk',
    child: [
      {
        href: '/risk-analyse/risks',
        title: 'menu.risk-analyse.risk',
      },
      {
        href: '/groupable/measure/groups',
        title: 'menu.risk-analyse.measures',
      },
      {
        href: '/risk-analyse/manage',
        title: 'menu.risk-analyse.manage',
      },
      {
        href: '/risk-analyse/risk-acceptance-decisions',
        title: 'menu.risk-analyse.risk-acceptance-decision',
      },
    ],
  },
  {
    href: '/users',
    title: 'menu.owner-registry',
    icon: 'mdi mdi-account-multiple',
  },
  {
    href: '/confidentiality-levels',
    title: 'menu.confidentiality-levels',
    icon: 'mdi mdi-chart-bar',
  },
  {
    href: '/document-references',
    title: 'menu.document-references',
    icon: 'mdi mdi-file-document',
  },
  {
    href: '/licences',
    title: 'menu.licences',
    icon: 'mdi mdi-badge-account',
  },
];

export default menuItems;
